import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const GrauDeInstrucao = () => {
  const [graus, setGraus] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    descricao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarGraus = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/grau-instrucao`);
      if (!response.ok) {
        throw new Error('Erro ao buscar graus de instrução');
      }

      const data = await response.json();

      const formatados = data.map((item) => ({
        id: item.id_grau_instrucao,
        descricao: item.nome_grau_instrucao,
        ativo: item.ativo
      }));

      setGraus(formatados);
    } catch (error) {
      console.error('Erro ao carregar graus de instrução:', error);
      alert('Erro ao carregar graus de instrução. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarGraus();
  }, []);

  const filteredGraus = graus.filter((grau) =>
    grau && grau.descricao && grau.descricao.toLowerCase().includes((searchTerm || '').toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_grau_instrucao: formData.descricao,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/grau-instrucao/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar grau de instrução');
        }

        const atualizado = await response.json();

        setGraus((prev) =>
          prev.map((grau) =>
            grau.id === editingId
              ? {
                  id: atualizado.id_grau_instrucao,
                  descricao: atualizado.nome_grau_instrucao,
                  ativo: atualizado.ativo
                }
              : grau
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/grau-instrucao`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar grau de instrução');
        }

        const criado = await response.json();

        setGraus((prev) => [
          ...prev,
          {
            id: criado.id_grau_instrucao,
            descricao: criado.nome_grau_instrucao,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar grau de instrução:', error);
      alert('Erro ao salvar grau de instrução. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (grau) => {
    setFormData({
      descricao: grau.descricao,
      ativo: grau.ativo
    });
    setEditingId(grau.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este grau de instrução?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/grau-instrucao/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir grau de instrução');
      }

      setGraus((prev) => prev.filter((grau) => grau.id !== id));
    } catch (error) {
      console.error('Erro ao excluir grau de instrução:', error);
      alert('Erro ao excluir grau de instrução. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({ descricao: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const grauSelecionado = graus.find((grau) => grau.id === id);

    if (!grauSelecionado) {
      return;
    }

    const novoAtivo = !grauSelecionado.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/grau-instrucao/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_grau_instrucao: grauSelecionado.descricao,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do grau de instrução');
      }

      const atualizado = await response.json();

      setGraus((prev) =>
        prev.map((grau) =>
          grau.id === id ? { ...grau, ativo: atualizado.ativo } : grau
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do grau de instrução:', error);
      alert('Erro ao atualizar status do grau de instrução. Tente novamente.');
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Grau de Instrução</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Grau de Instrução' : 'Cadastrar Grau de Instrução'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="descricao">Descrição *</label>
              <input
                type="text"
                id="descricao"
                value={formData.descricao}
                onChange={(e) => setFormData({...formData, descricao: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite a descrição do grau de instrução"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Cadastrar')}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar graus de instrução..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando graus de instrução...'
                  : `${filteredGraus.length} registro(s) encontrado(s)`}
              </span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Grau
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Descrição</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredGraus.map(grau => (
                  <tr key={grau.id}>
                    <td className="col-id">{grau.id}</td>
                    <td className="col-nome">{grau.descricao}</td>
                    <td className="col-status">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={grau.ativo}
                          onChange={() => handleToggleStatus(grau.id)}
                          id={`toggle-${grau.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(grau)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(grau.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredGraus.length === 0 && !loading && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum grau de instrução encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo grau.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GrauDeInstrucao;
